import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Flying extends Component {
	render() {
		return (
			<div className='row' style={styles.container}>
				<div className='col-xs-12 col-sm-12 col-md-offset-3 col-md-6 col-lg-offset-4 col-lg-4'>
					<div className='panel panel-default'>
						<div className='panel-heading' style={{textAlign: 'center'}}>
							<Link to='/' className='pull-left' style={styles.back}>
								<span className='glyphicon glyphicon-chevron-left'></span>
							</Link>
							Flight Tools
						</div>
						<div className='panel-body'>
							<p>
								<a
									href='/navigation-flight-log.html'
									target='_blank'
									rel='noopener noreferrer'
									style={styles.link}
								>
									Navigation Flight Log
								</a>
							</p>
							<p>
								<a
									href='http://notams.rascanoo.com'
									target='_blank'
									rel='noopener noreferrer'
									style={styles.link}
								>
									NOTAMs
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default Flying;

const styles = {
	container: {
		margin: '10px 0px 30px 0px'
	},
	link: {
		fontSize: '1.5em',
		textDecoration: 'none',
		color: '#000'
	},
	back: {
		color: '#000',
		textDecoration: 'none'
	}
}



// WEBPACK FOOTER //
// ./src/Flying.js